import Query from '../../../components/Report';

const query = (keyword) =>
    new Query('search-keywords-keywords-details', {
        keyword,
    });

export default query;
